const PaymentStatus = {
  Success: "success",
  Voided: "voided",
};

export default PaymentStatus;
